import { useEffect, useReducer } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { getLocalStorage, setLocalStorage } from 'localstorage'
import { getUsignData } from '../../services/getUsignData'
import mountReducer from '../../services/pagination'
import { hookUrl } from '../../constants'
import BTPOpening from '../btpOpening'
import BTPPromoted from '../btpPromoted'
import BTPCalhau from '../btpCalhau'
import './style.scss'

const openingTime = 5

const getInitialState = props => {
    const initState = {
        showData: false,
        showNoData: false,
        loading: 'waitingLoad',
        finishedOpening: false,
        msgs: [],
        cacheIndexName: '',
        hookURL: '',
        limite: props.amount,
        loop: props.loop,
        interval: props.duration,
        toPlay: [],
        // started: false,
    }

    const newHook = `${hookUrl}?evento=promovido`
    const newCacheName = `btp_promovido_v0`

    if (props.msgId) {
        return {
            ...initState,
            hookURL: `${newHook}&id=${props.msgId}${
                props.preview ? '&preview=1' : ''
            }`,
            cacheIndexName: newCacheName,
            limite: 1,
        }
    }

    return {
        ...initState,
        cacheIndexName: newCacheName,
        hookURL: `${newHook}${`&limite=${
            props.amount > 10 ? `&limite=${props.amount}` : ''
        }`}`,
        toPlay: getLocalStorage(newCacheName, initState.toPlay),
    }
}

const BTPPage = props => {
    const [state, dispatch] = useReducer(mountReducer, props, getInitialState)

    useEffect(() => {
        if (state.hookURL !== '' && state.loading === 'waitingLoad') {
            dispatch({ type: 'changeLoading', payload: 'loading' })
            getUsignData(state.hookURL, newData => {
                dispatch({
                    type: 'newData',
                    payload: newData,
                })
            })
        }
    }, [state.hookURL, state.loading])

    useEffect(() => {
        if (
            state.cacheIndexName !== '' &&
            state.toPlay.length > 0 &&
            state.msgs.length > 0
        ) {
            setLocalStorage(state.cacheIndexName, state.toPlay, 3600)
        }
    }, [state.cacheIndexName, state.msgs, state.toPlay])

    if (state.showNoData) {
        return <BTPCalhau cbFinished={() => dispatch({ type: 'callNext' })} />
    }

    const curMsg = state.msgs[state.toPlay[0]]
    // console.log('CurMsg:', curMsg)
    // console.log('state.toPlay[0]:', state.toPlay[0])

    if (state.showData && state.finishedOpening && curMsg) {
        return (
            <TransitionGroup>
                <CSSTransition
                    key={curMsg._id}
                    in={state.showData}
                    appear
                    timeout={1000}
                    classNames='news'
                >
                    <BTPPromoted
                        news={curMsg}
                        cbFinished={() => dispatch({ type: 'callNext' })}
                        interval={state.interval}
                    />
                </CSSTransition>
            </TransitionGroup>
        )
    }
    if (state.showData && !state.finishedOpening) {
        return (
            <TransitionGroup>
                <CSSTransition
                    in={!state.showData}
                    appear={false}
                    timeout={100}
                    classNames='news'
                >
                    <BTPOpening
                        cbFinished={() => dispatch({ type: 'finishLoading' })}
                        interval={openingTime}
                    />
                </CSSTransition>
            </TransitionGroup>
        )
    }
    return null
}

export default BTPPage
